import { useEffect, useMemo, useSyncExternalStore } from 'react';
import {
  abonniereMeineRechte,
  holeMeineRechte,
  meineRechteStand,
} from '../../services/rechte/rechteService';
import { vertriebRechteHinterWache, type VertriebRechte } from './vertriebRechte';

/**
 * Schreibwege einer Vertriebsansicht (Kunden, Neukunden, Karte) — für
 * Ansichten hinter der Wache in App.tsx, die die Systemrolle nicht kennen.
 * Liest denselben Sitzungsspeicher wie `useRechte`; die Regel steht in
 * `vertriebRechteHinterWache`.
 */
export function useVertriebRechte(): VertriebRechte {
  const stand = useSyncExternalStore(abonniereMeineRechte, meineRechteStand, meineRechteStand);
  // App fragt ohnehin an; hier nur, falls die Ansicht einmal ohne sie läuft.
  useEffect(() => { holeMeineRechte(); }, []);
  return useMemo(() => vertriebRechteHinterWache(stand.dbRechte), [stand]);
}
